import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { Logger } from "src/app/@common/log/logger";
import { V2GeneralResource } from "src/app/@generated/api/v2-general.resource";
import { GeneralInfo } from "src/app/@generated/model/general-info";

@Injectable({
    providedIn: 'root',
})
export class GeneralService {
    private logger = inject(Logger);
    private generalResource = inject(V2GeneralResource);
    returnGeneralInfo(): Observable<GeneralInfo> {
        return this.generalResource.getGeneralInfo();
    }
}